import { useMemo } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import ImageViewer from 'components/field/ImageViewer';
import Accordion from 'components/global/Accordion';
import Typography from 'components/global/Typography';
import { Video } from 'components/global/Video';

import useLocale from 'hooks/useLocale';

export const FrequentlyAskedQuestion = ({ formName }) => {
	const { t } = useTranslation();
	const { refereeAmount, refererAmount } = useSelector((state) => state.user.localization);
	const { Currency } = useLocale();

	const AccordionArr = useMemo(() => {
		const arr = [];
		for (let i = 1; i < 30; i += 1) {
			if (t(`${formName}.question${i}`) !== `${formName}.question${i}`) {
				arr.push(i);
			} else {
				break;
			}
		}
		return arr;
	}, [formName, t]);

	return AccordionArr.map((i) => (
		<Accordion header={t(`${formName}.question${i}`)} defaultVisible={i === 1} key={i}>
			<Typography noWrap>
				<Trans
					i18nKey={`${formName}.answer${i}`}
					components={{
						linkViewer: <LinkViewer />,
						image: <ImageViewer />,
						videoViewer: <VideoViewer formName={formName} />
					}}
					values={{
						refereeAmount: `${refereeAmount} ${Currency}`,
						refererAmount: `${refererAmount} ${Currency}`
					}}
				/>
			</Typography>
		</Accordion>
	));
};

const LinkViewer = ({ children }) => {
	const { t } = useTranslation();
	return <a href={children}>{t(children)}</a>;
};

const VideoViewer = ({ children, formName }) => (
	<Video
		controls
		logo="https://storage.googleapis.com/tryoto-public/public/assets/images/otoLogo.png"
		title={`${formName}.videoTitle`}
		variant="inline"
		videoId={Array.isArray(children) ? children[0].split('=')[1] : children}
	/>
);
